import request from '@/config/axios'

export interface O2oCouponTemplateVO {
  id?: number
  name?: string
  description?: string
  status?: number
  totalCount?: number
  takeLimitCount?: number
  takeType?: number
  usePrice?: number
  productScope?: number
  productScopeValues?: number[]
  validityType?: number
  validStartTime?: string
  validEndTime?: string
  fixedStartTerm?: number
  fixedEndTerm?: number
  discountType?: number
  discountPercent?: number
  discountPrice?: number
  discountLimitPrice?: number
  takeCount?: number
  useCount?: number
}

export interface O2oCouponSendResult {
  targetCount?: number
  successCount?: number
  skipCount?: number
  stoppedByStock?: boolean
  message?: string
}

export const O2oCouponApi = {
  getTemplatePage: async (params: any) => {
    return await request.get({ url: '/o2o/coupon/template/page', params })
  },
  getTemplate: async (id: number) => {
    return await request.get({ url: '/o2o/coupon/template/get?id=' + id })
  },
  createTemplate: async (data: O2oCouponTemplateVO) => {
    return await request.post({ url: '/o2o/coupon/template/create', data })
  },
  updateTemplate: async (data: O2oCouponTemplateVO) => {
    return await request.put({ url: '/o2o/coupon/template/update', data })
  },
  updateTemplateStatus: async (id: number, status: number) => {
    return await request.put({
      url: '/o2o/coupon/template/update-status',
      params: { id, status }
    })
  },
  deleteTemplate: async (id: number) => {
    return await request.delete({ url: '/o2o/coupon/template/delete?id=' + id })
  },
  getCouponPage: async (params: any) => {
    return await request.get({ url: '/o2o/coupon/page', params })
  },
  getSendTargetCount: async () => {
    return await request.get({ url: '/o2o/coupon/send-target-count' })
  },
  send: async (data: {
    templateId: number
    sendAll?: boolean
    userIds?: number[]
  }): Promise<O2oCouponSendResult> => {
    return await request.post({ url: '/o2o/coupon/send', data })
  }
}
